/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  attach: {
    type: [String, Function],
    "default": ""
  },
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  delay: {
    type: Number,
    "default": 0
  },
  fullscreen: Boolean,
  indicator: {
    type: [Boolean, Function],
    "default": true
  },
  inheritColor: Boolean,
  loading: {
    type: Boolean,
    "default": true
  },
  preventScrollThrough: {
    type: Boolean,
    "default": true
  },
  showOverlay: {
    type: Boolean,
    "default": true
  },
  size: {
    type: String,
    "default": "medium"
  },
  text: {
    type: [String, Function]
  },
  zIndex: {
    type: Number
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
